'use client';

import { Text, Badge } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import {
  getCurrentRootDomain,
  getDomainDisplayName,
} from '../../utils/environmentDetection';

export type RuntimeEnvironmentNoticeProps = {
  variant?: 'badge' | 'default';
  size?: 'sm' | 'md';
};

export function RuntimeEnvironmentNotice({
  variant = 'default',
  size = 'md',
}: RuntimeEnvironmentNoticeProps) {
  const t = useTranslations('signIn');
  const displayName = getDomainDisplayName(getCurrentRootDomain());

  if (!displayName) {
    return null;
  }

  if (variant === 'badge') {
    return (
      <Badge size={size} variant="emphasis">
        {displayName}
      </Badge>
    );
  }

  return (
    <Text fontSize="xs" color="fg.muted" textAlign="center">
      {t.rich('currentEnvironment', {
        environment: displayName,
        highlight: (chunks) => (
          <Text fontWeight="bold" as="span">
            {chunks}
          </Text>
        ),
      })}
    </Text>
  );
}
